/**
 * Layout helpers for Admin Dashboard → Listings card list.
 * Replaces the previous sticky-column table approach which was architecturally
 * unreliable at typical desktop widths (table min-width near container width
 * caused sticky column offset failures and inconsistent horizontal scroll).
 */

export const ADMIN_LISTINGS_TABLE_TEST_ID = 'admin-listings-list';

export const ADMIN_LISTINGS_CARD_FIELDS = [
  'listing',
  'owner',
  'photos',
  'status',
  'reviewer',
  'price',
  'actions',
  'expand',
];

export function adminListingsActionsCellTestId(listingId) {
  return `admin-listings-row-${listingId}`;
}

export function adminListingsRowBg({ isPriority, isReady }) {
  if (isPriority && isReady) return 'bg-orange-50/40 hover:bg-orange-100/40';
  if (isReady) return 'bg-amber-50/40 hover:bg-amber-100/40';
  return 'hover:bg-slate-50';
}
